export default __webpack_public_path__ + "static/media/add.d66c13e2.svg";